import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ioDispatcher() {
  return Dispatchers_getInstance().c13_1;
}
//region block: exports
export {
  ioDispatcher as ioDispatcher3b9pa3x0duop,
};
//endregion

//# sourceMappingURL=IODispatcher.web.mjs.map
